export enum TaskCheckTypeEnum {
    REPAIR = 'Repair',
    MAINTENANCE = 'Maintenance',
    CHECK = 'Check',
}
